import { createUseStyles } from 'react-jss';

const styles = {
  content: { paddingBottom: '5rem', position: 'relative', minHeight: '10rem' },
  tableContent: { maxWidth: '80vw' },
  bcForm: { paddingLeft: '2rem' },
  configButton: {
    margin: { top: 0, bottom: '7.2rem', left: 'auto', right: 'auto' },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
